import { auth, database } from '../firebase/firebaseConfig';
import { push, ref, serverTimestamp, set } from 'firebase/database';

const BUG_REPORTS_ROOT = 'bugReports';

const resolveUserPath = (userId) => {
  if (userId) {
    return `users/${userId}/${BUG_REPORTS_ROOT}`;
  }
  return BUG_REPORTS_ROOT;
};

export const submitBugReport = async ({
  summary,
  details,
  reporterEmail,
  includeContext,
  contextData,
  environment,
}) => {
  const reporterUid = auth.currentUser?.uid || null;
  const targetUserId = contextData?.userId || reporterUid || null;
  const basePath = resolveUserPath(targetUserId);
  const reportRef = push(ref(database, basePath));
  const createdAtClient = Date.now();

  const payload = {
    summary: summary || '',
    details: details || '',
    reporterEmail: reporterEmail || null,
    includeContext: !!includeContext,
    status: 'open',
    createdAt: serverTimestamp(),
    createdAtClient,
    reporterUid,
    reportedForUserId: targetUserId,
  };

  if (includeContext && contextData) {
    payload.context = contextData;
  }

  if (includeContext && environment) {
    payload.environment = environment;
  }

  await set(reportRef, payload);

  return {
    id: reportRef.key,
    ...payload,
  };
};
